import React from 'react';
interface CenterMarkSelectorProps {
  selectedMark: string;
  onMarkChange: (mark: string) => void;
}
export function CenterMarkSelector({
  selectedMark,
  onMarkChange
}: CenterMarkSelectorProps) {
  const handleMarkChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    onMarkChange(e.target.value);
  };
  const surveyingMarks = [{
    value: 'triangle',
    icon: '△',
    label: 'Triangle vide'
  }, {
    value: 'triangle2',
    icon: '▲',
    label: 'Triangle plein'
  }, {
    value: 'circledot',
    icon: '⊙',
    label: 'Rond avec trou'
  }, {
    value: 'none',
    icon: '—',
    label: 'Aucune marque'
  }];
  return <div className="rounded-xl border-2 bg-white p-6 shadow-sm transition-shadow hover:shadow-md" style={{
    borderColor: '#E5E7EB'
  }} data-id="element-13">
      <div className="mb-6 text-sm font-bold uppercase tracking-wide" style={{
      color: '#6B4423'
    }} data-id="element-14">
        Marque centrale
      </div>
      <div className="grid grid-cols-2 gap-4" data-id="element-15">
        {surveyingMarks.map(mark => <label key={mark.value} className="flex cursor-pointer flex-col items-center gap-3 rounded-lg p-4 transition-all hover:shadow-md" style={{
        backgroundColor: selectedMark === mark.value ? '#FEF3F2' : 'transparent'
      }} data-id="element-16">
            <input type="radio" name="centerMark" value={mark.value} checked={selectedMark === mark.value} onChange={handleMarkChange} className="hidden" data-id="element-17" />
            <div className="flex h-16 w-16 items-center justify-center rounded-lg border-2 bg-white text-3xl transition-all" style={{
          borderColor: selectedMark === mark.value ? '#6B4423' : '#D1D5DB',
          color: '#000000'
        }} data-id="element-18">
              {mark.icon}
            </div>
            <span className="text-center text-xs font-medium" style={{
          color: '#000000'
        }} data-id="element-19">
              {mark.label}
            </span>
          </label>)}
      </div>
    </div>;
}